/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAclDestroy } from '../../axios/campaignAclDestroy'
import type {
	CampaignAclDestroyError,
	CampaignAclDestroyPathParams,
	CampaignAclDestroyResponse,
} from '../../types/CampaignAclDestroy'

export const campaignAclDestroyMutationKey = () => [{ url: '/campaigns/:campaign/access/:user' }] as const

export type CampaignAclDestroyMutationKey = ReturnType<typeof campaignAclDestroyMutationKey>

export type CampaignAclDestroyVariables = {
	campaign: CampaignAclDestroyPathParams['campaign']
	user: CampaignAclDestroyPathParams['user']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::destroy */
export function useCampaignAclDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignAclDestroyResponse,
		AxiosError<CampaignAclDestroyError>,
		CampaignAclDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignAclDestroyMutationKey(),
		mutationFn: ({ campaign, user }: CampaignAclDestroyVariables) =>
			campaignAclDestroy(campaign, user, config).then(res => res.data),
		...options,
	})
}
